<template>
  <div class="q-privacy">
    <vh-dialog
      title="隐私协议设置"
      :visible.sync="dialogVisbale"
      :modal-append-to-body="false"
      width="600px"
      :before-close="handleClose"
    >
      <div class="privacy_box">
        <div class="flex_box">
          <span class="labelRight">隐私协议</span
          ><ComInput
            :max-length="100"
            v-model="privacyConten"
            @change="(val) => (item.name = val)"
          ></ComInput>
        </div>
        <div v-for="(item, index) in details" :key="index" class="posi">
          <div class="flex_box">
            <span class="labelRight">协议名称</span>
            <ComInput
              :max-length="100"
              v-model="item.name"
              @change="(val) => (item.name = val)"
              @blur="
                (el) => {
                  changeName(el, item.name, index);
                }
              "
            ></ComInput>
            <span class="wid_i">
              <i
                class="iconfont-v3 saasicon_fangda"
                @click="addOption"
                v-show="details.length == 1"
              ></i>
              <i
                class="vh-icon-remove-outline"
                @click="delOption(item.name, index)"
                v-show="index == 1"
              ></i
            ></span>
          </div>
          <div v-show="item.nameErrTip" class="nameErrTip">
            {{ item.nameErrTip }}
          </div>
          <div class="flex_box">
            <span class="labelRight">跳转链接</span
            ><ComInput
              class="tarea"
              @blur="(el) => checkUrl(item, item.url, index)"
              v-model="item.url"
              :max-length="200"
              type="textarea"
              placeholder="请输入以http://或https://开头的链接"
              @change="(val) => (item.url = val)"
            ></ComInput>
            <span class="block_"></span>
          </div>
          <div v-if="item.urlErrTip" class="urlErrTip">
            {{ item.urlErrTip }}
          </div>
        </div>
        <div class="flex_box">
          <span class="labelRight">预览效果</span>
          <div v-html="previewPrivacy" class="previewH"></div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <vh-button type="primary" size="medium" round @click="savePrivacy"
          >确 定</vh-button
        >
        <vh-button size="medium" plain type="info" @click="handleClose" round>取 消</vh-button>
      </span>
    </vh-dialog>
    <!-- 预览效果 -->
    <div
      v-if="isPreview"
      class="flex_box preview_pad"
      :class="{ preview_pad_wap: isH5 }"
    >
      <!-- <vh-checkbox v-model="privacyChecked" class="sure"></vh-checkbox> -->
      <div v-html="previewPrivacy" class="previewH"></div>
      <div class="errtip" v-if="errTipShow && !privacyChecked">
        {{$t('privacy.privacy_1007')}}
      </div>
    </div>
  </div>
</template>

<script>
import ComInput from "./input/com.vue";
export default {
  props: ["showPrivacyDialog", "privacyDate", "isPreview"],
  components: {
    ComInput,
  },
  inject: ["isH5"],
  data() {
    return {
      privacyConten: "我们根据《隐私声明》保护您填写的所有信息",
      details: [{ name: "《隐私声明》", url: "", urlErrTip: "" }],
      proviewVal: "",
      previewPrivacy: "",
      privacyNames: [],
      privacyChecked: false,
      errTipShow: false,
      dialogVisbale: this.showPrivacyDialog,
    };
  },
  watch: {
    privacyConten: {
      handler(val) {
        this.assemble();
      },
      // immediate: true,
    },
    privacyDate: {
      handler(val) {
        console.log("privacyDate", val);
        if (val && val.privacyConten) {
          this.privacyConten = val.privacyConten;
          this.details = JSON.parse(JSON.stringify(val.details));
          this.details.forEach((i) => {
            this.$set(i, "nameErrTip", "");
            this.$set(i, "urlErrTip", "");
          });
        }
      },
      immediate: true,
    },
    // details:{
    //   handler(val) {
    //     val.forEach(item=>{
    //       if(!this.privacyNames.includes(item.name)){
    //         this.regName()
    //       }
    //     })
    //   },
    //   deep: true,
    // }
  },
  mounted() {
    // console.log(this.privacyDate, "mounted");
    this.regName();
  },
  methods: {
    // 关闭弹框
    handleClose() {
      this.dialogVisbale = false;
      this.$emit("toggolSetPravacy");
    },
    // 保存协议内容
    savePrivacy() {
      this.details.forEach((i) => {
        if (!i.name) {
          i.nameErrTip = "请输入协议名称";
        }
      });
      if (this.details.some((i) => !!i.urlErrTip)) return;
      if (!this.details.every((i) => !!i.name) || !this.privacyConten) return;
      this.handleClose();
      this.$emit("savePrivacy", {
        details: this.details,
        privacyConten: this.privacyConten,
      });
    },
    // 添加协议
    addOption() {
      if (this.privacyConten.length > 92) {
        this.$message.warning("添加隐私协议会超出预览字数，请删减后再添加");
        return;
      }
      this.details.push({
        name: `《隐私声明2》`,
        url: "",
        urlErrTip: "",
        nameErrTip: "",
      });
      this.privacyConten = this.privacyConten.replace(
        this.details[0].name,
        `${this.details[0].name}和${this.details[1].name}`
      );
      console.log(this.privacyConten, this.details, "addOption");
    },
    // 删除协议
    delOption(val, index) {
      let str = "";
      if (index == 0) {
        str = `${val}和`;
      } else {
        str = `和${val}`;
      }
      this.privacyConten = this.privacyConten.replace(str, "");
      this.details = this.details.filter((item, i) => i != index);
      console.log(
        this.privacyConten,
        this.privacyConten.replace(str, ""),
        str,
        index,
        "delOption"
      );
      this.regName();
    },
    // 修改协议名称
    changeName(el, val, index) {
      console.log(val, "changeName");
      if (this.privacyConten.includes(val)) {
        this.details[index].name = val;
        this.details[index].nameErrTip = "";
      } else {
        this.details[index].name = "";
      }
      this.assemble();
    },
    // 正则协议名称
    regName() {
      // let arr = this.privacyConten.match(/《[^》]+》/g);
      // this.privacyNames = arr;
      // console.log(
      //   this.privacyConten,
      //   arr,
      //   this.privacyConten.match(/《[^》]+》/g),
      //   "regName"
      // );
      // if (this.details.length == 1) {
      //   this.details[0].name = arr[0];
      // } else {
      //   this.details[0].name = arr[0];
      //   this.details[1].name = arr[1];
      // }
      this.assemble();
    },
    // 预览内容拼装
    assemble() {
      let str = this.privacyConten;
      let rex = `|^-^+^+^-^|`;
      let arr = JSON.parse(JSON.stringify(this.details));
      if (
        this.details.length == 2 &&
        this.details[0].name == this.details[1].name
      ) {
        arr.shift();
      }
      arr.forEach((item) => {
        // console.log(item, "item");
        if (item.name) {
          str = str.replace(item.name, rex);
        }
      });
      arr.forEach((item) => {
        // console.log(item, "item");
        if (item.name) {
          str = str.replace(
            rex,
            `<a href="${item.url || "javascript:void(0);"}" target="${
              item.url ? "_blank" : "_self"
            }">${item.name}</a>`
          );
        }
      });
      this.previewPrivacy = str;
    },
    // 检查参数
    check() {
      this.errTipShow = !this.privacyChecked;
    },
    // 检测url
    checkUrl(i, val, index) {
      console.log(i, val, index, "data,index");
      if (val) {
        let flag = /^(((https|http)?):\/\/)[0-9,a-z,A-Z]+/.test(val);
        if (flag) {
          i.urlErrTip = "";
        } else {
          i.urlErrTip = "请输入正确的网址";
        }
      }
      this.assemble();
    },
  },
};
</script>

<style lang="scss">
// @import "../icon-font/iconfont.css";
.q-privacy {
  .posi {
    position: relative;
    .urlErrTip {
      position: absolute;
      bottom: -18px;
      left: 74px;
      color: #fb3a32;
      font-size: 12px;
    }
    .nameErrTip {
      position: absolute;
      bottom: 60px;
      left: 74px;
      color: #fb3a32;
      font-size: 12px;
    }
  }
  .flex_box {
    display: flex;
    margin-bottom: 20px;
    .labelRight {
      flex-shrink: 0;
      width: 75px;
      line-height: 40px;
    }
    .tarea.com-input {
      height: 56px;
    }
    .limit.area {
      transform: none;
      bottom: 4px;
      right: 8px;
    }
    .wid_i{
      width: 16px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      i {
        font-size: 20px;
      }
    }
    .saasicon_fangda,
    .saasicon_delete {
      line-height: 40px;
      cursor: pointer;
    }
    .block_ {
      width: 16px;
      flex-shrink: 0;
    }
    .previewH {
      line-height: 40px;
      text-align: left;
      a {
        text-decoration: none;
        color: #3562fa;
      }
    }
    .sure {
      line-height: 40px;
      margin-right: 8px;
    }
  }
  .preview_pad {
    padding: 0 75px;
    font-size: 14px;
    position: relative;
    color: #606266;
    .errtip {
      position: absolute;
      flex-shrink: 0;
      color: #fb3a32;
      font-size: 12px;
      bottom: -5px;
    }
  }
  .preview_pad_wap {
    padding: 20px;
    .previewH,
    .sure {
      line-height: 1;
    }
    .errtip {
      bottom: 0;
    }
  }
}
</style>
